// extracted by css-extract-rspack-plugin
var _1 = "L2Dqt";
var _2 = "JRB3P";
export { _1 as "dragHelperStyleOtherBrowsers", _2 as "dragHelperStyleSafari" }
